import { render, staticRenderFns } from "./OwnArchive.vue?vue&type=template&id=32387f6d"
import script from "./OwnArchive.vue?vue&type=script&lang=js"
export * from "./OwnArchive.vue?vue&type=script&lang=js"
import style0 from "./OwnArchive.vue?vue&type=style&index=0&id=32387f6d&prod&lang=scss"
import style1 from "./OwnArchive.vue?vue&type=style&index=1&id=32387f6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports